import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
const ErrorMessage = (props) => {
    const {
        urlToRedirect,
        message,
        genericMessage,
        attempts,
        errorButtons,
        onAcceptMessage,
        labelButton
    } = props;
    const goToHomeHandler = () => {
        window.location.href = urlToRedirect;
    };
    const goToProductPage = () => {
        if(typeof window['closeEligibilityCallback'] === 'function') {
            window['closeEligibilityCallback']();
        }
    };
    return (
        <Grid
            container
            spacing={2}
            direction="column"
            alignItems="center"
            justify="center"
        >
            <Grid item xs={12}>
                <Typography
                    align="center"
                    variant="h4"
                    tabIndex="0"
                    gutterBottom
                >
                    {message ||
                        "It looks like something went wrong."}
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography
                    align="center"
                    variant="h5"
                    tabIndex="0"
                    gutterBottom
                >
                    {genericMessage || ""}
                </Typography>
            </Grid>
            <Grid item container
                  xs={12}
                  direction="row"
                  justify="space-around"
                  alignItems="center"
            >
                {attempts > 3 ? (
                    <Button
                        onClick={goToHomeHandler}
                        variant="contained"
                        color="primary"
                    >
                        {"Return to Home"}
                    </Button>
                ) : (
                    errorButtons?.length ? (
                        <React.Fragment>
                            {errorButtons.map((button) => {
                                let toProductPage = button?.type === 'toProductPage';
                                return (
                                    <Button
                                        onClick={
                                            toProductPage ? goToProductPage: onAcceptMessage
                                        }
                                        variant="contained"
                                        color={toProductPage ? 'secondary' : 'primary'}
                                    >
                                        {button.label}
                                    </Button>
                                )
                            })}
                        </React.Fragment>
                    ) : (
                        <Button
                            onClick={onAcceptMessage}
                            variant="contained"
                            color="primary"
                        >
                            {labelButton || "Back"}
                        </Button>
                    )
                )}
            </Grid>
        </Grid>
    );
};

export default ErrorMessage;
